import React, { useState } from 'react';
import { FiAlertTriangle, FiCheckCircle } from 'react-icons/fi';
import css from './ConsultaNfs.module.css';

/* ── Sequência de um grupo (série): números pulados, repetidos e justificativas ──
   api = { justificar(corpo), remover(id) } -- NFS-e e NFC-e têm rotas próprias */
function GrupoSequencia({ g, titulo, sub, clienteId, onMudou, setErro, api }) {
  const [editando, setEditando] = useState(null);
  const [motivo, setMotivo] = useState('');
  async function salvar(f) {
    try { await api.justificar({ cliente_id: clienteId, serie: g.serie, inicio: f.inicio, fim: f.fim, motivo }); setEditando(null); setMotivo(''); onMudou(); }
    catch (e) { setErro(e.message); }
  }
  async function remover(f) {
    if (!window.confirm(`Remover a justificativa dos números ${f.inicio === f.fim ? f.inicio : `${f.inicio} a ${f.fim}`}?`)) return;
    try { await api.remover(f.justificativa.id); onMudou(); } catch (e) { setErro(e.message); }
  }
  const faixa = (f) => (f.inicio === f.fim ? `Nº ${f.inicio}` : `Nº ${f.inicio} a ${f.fim}`);
  return (
    <div className={css.seqCard}>
      <div className={css.seqTopo}>
        <div><strong>{titulo}</strong><small>{sub}</small></div>
        {g.pendentes ? <span className={css.seqAlerta}><FiAlertTriangle size={12} /> {g.pendentes} número(s) pulado(s)</span>
          : <span className={css.seqOk}><FiCheckCircle size={12} /> Sequência completa</span>}
      </div>
      <div className={css.seqNums}>
        <div><span>Notas</span><strong>{g.quantidade}</strong></div>
        <div><span>Primeiro</span><strong>{g.primeiro ?? '—'}</strong></div>
        <div><span>Último</span><strong>{g.ultimo ?? '—'}</strong></div>
        <div><span>Canceladas</span><strong>{g.canceladas}</strong></div>
      </div>
      {g.faltantes.map(f => (
        <div key={`${f.inicio}-${f.fim}`} className={`${css.seqLinha} ${f.justificativa ? css.seqJust : ''}`}>
          <span className={css.seqFaixa}>{faixa(f)}<small>{f.qtd > 1 ? `${f.qtd} números · ` : ''}entre {f.entre[0]} e {f.entre[1]}</small></span>
          {f.justificativa ? (
            <>
              <span className={css.seqMotivo}>Justificado: {f.justificativa.motivo}{f.justificativa.por ? ` · ${f.justificativa.por}` : ''}</span>
              <button type="button" onClick={() => remover(f)}>Remover</button>
            </>
          ) : editando === f.inicio ? (
            <>
              <input className={css.input} autoFocus placeholder="Motivo (ex.: inutilizada, DPS descartada)" value={motivo} onChange={e => setMotivo(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') salvar(f); }} />
              <button type="button" onClick={() => salvar(f)} disabled={motivo.trim().length < 3}>Salvar</button>
              <button type="button" onClick={() => { setEditando(null); setMotivo(''); }}>Cancelar</button>
            </>
          ) : (
            <>
              <span className={css.seqPendente}>Não encontrada</span>
              <button type="button" onClick={() => { setEditando(f.inicio); setMotivo(''); }}>Justificar</button>
            </>
          )}
        </div>
      ))}
      {g.duplicados.map(d => (
        <div key={`d${d.numero}`} className={css.seqLinha}>
          <span className={css.seqFaixa}>Nº {d.numero}<small>{d.chaves.length} notas com o mesmo número</small></span>
          <span className={css.seqPendente}>Número repetido</span>
        </div>
      ))}
    </div>
  );
}

export default GrupoSequencia;
